import React, {useEffect, useRef, useState} from 'react'
import {Lang} from 'yougile-lang'
import {
  InputWithSuggest,
  SuggestItem
} from '@components/common/input-with-suggest/input-with-suggest'
import {CustomFieldRow} from './field-row'

export type ConfirmedSuggestItem = {
  id?: string
  value: string
}

interface Props {
  label: string
  value?: string
  suggestions: SuggestItem[]
  getAddAsNewLabel?: (value: string) => string
  onConfirm: (item: ConfirmedSuggestItem) => void
}

export const CustomFieldInputWithSuggest = ({
  label,
  value,
  suggestions,
  getAddAsNewLabel,
  onConfirm
}: Props) => {
  const initialValue = value ?? ''

  const [editedValue, setEditedValue] = useState(initialValue)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setEditedValue(initialValue ?? '')
  }, [initialValue])

  const handleChange = (val: string) => {
    setEditedValue(val)
  }

  return (
    <CustomFieldRow label={label}>
      <InputWithSuggest
        inputRef={inputRef}
        value={editedValue}
        getAddAsNewLabel={getAddAsNewLabel}
        addAsNewButtonBehavior="always"
        onChange={handleChange}
        onSelect={item => {
          const confirmedItem: ConfirmedSuggestItem = {value: editedValue}

          if (!item.isNew) {
            confirmedItem.id = item.id
          }

          onConfirm(confirmedItem)
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onConfirm({value: editedValue})
            inputRef?.current.blur()
          }
        }}
        items={suggestions}
        className="flex-1"
        inputClassName={
          'shadow-none hover:shadow-border-1 hover:shadow-line-base focus:shadow-border-1'
        }
        placeholder={Lang.msg.empty}
      />
    </CustomFieldRow>
  )
}
